import { observable, action, runInAction} from 'mobx'
import { json } from '../../../../utils/ajax'

class EAtalsContents {
  // 数据
  @observable level1Directory
  @observable childrenDirectory
  @observable content
  // 控制
  @observable loading
  @observable modal
  @observable level1Selected
  @observable carSeriesName
  @observable directoryName
  @observable childrenSelected
  @observable openKeys
  @observable pdfContents
  @observable pdfData

  constructor () {
    this.loading = false
    this.content = {test:[],pdf:{}}
    this.level1Directory = []
    this.childrenDirectory = []
    this.modal = 'hide'
    this.level1Selected = ''
    this.childrenSelected = ''
    this.carSeriesName = ''
    this.directoryName = ''
    this.openKeys = []
    this.pdfContents = []
    this.pdfData = {}
  }

  @action.bound
  openMenu = (openKeys) => {
    this.openKeys = openKeys
  }

  @action
  init = async (carSeriesId,level1Id, directoryId) => {
    runInAction(()=>{
      this.loading = true
      this.content = {test:[],pdf:{}};
    })
    const carSeries = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/carseriesCatalog/carseries/id/${carSeriesId}`)
    if(carSeries && carSeries.status === 0){
      return;
    }
    runInAction(() => {
      this.carSeriesName = carSeries.carseriesName
      this.pdfData = carSeries
      this.loading = false
    })
    await this.__findDirectoryByDirectoryId(carSeriesId,level1Id, directoryId)
  }
  __findDirectoryByDirectoryId = async (carSeriesId,level1Id, directoryId) => {
    runInAction(() => {
      this.loading = true
      this.carSeriesId = carSeriesId
      this.level1Directory = [];
      this.childrenDirectory = [];
      this.content = {test:[],pdf:{}};
    })

    let catalog;
    if (directoryId && directoryId!=='none') {
      catalog = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/Catalog/lv3IdQueryPathId/${directoryId}`)
    } else {
      catalog = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/by/carseries/${carSeriesId}`)
    }
    if(catalog && catalog.status === 0){
      runInAction(() => {
        this.loading = false
      })
      return
    }
    const path = catalog.pathId.split('/')
    const level1Directory = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/lv1CatalogList?carseriesId=${carSeriesId}`)
    if (!level1Directory.length) {
      runInAction(() => {
        this.loading = false
      })
      return
    }
    const childrenDirectory = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/lv1BelowCatalog?carseriesId=${carSeriesId}&pId=${path[0]}`)
    const content = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/content/theFrontDeskQueriesTheContentAccordingToTheCatalogId?catalogId=${catalog.id}`)
    runInAction(() => {
      this.level1Directory = level1Directory
      this.childrenDirectory = childrenDirectory
      this.level1Selected = level1Id==='none'? path[0]:level1Id
      this.childrenSelected = catalog.id
      this.content = content
      this.openKeys = path.slice(1, path.length - 1)
      this.directoryName = catalog.defaultName
      this.loading = false
    })
  }

  @action
  getChildrenTree = async (level1Selected) => {
    runInAction(() => {
      this.loading = true
    })
    const childrenDirectory = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/catalog/lv1BelowCatalog?carseriesId=${this.carSeriesId}&pId=${level1Selected}`)
    if (!childrenDirectory.length) {
      runInAction(() => {
        this.loading = false
      })
      return
    }
    const {path, name} = this.__findChildrenDirectoryPathAndName(childrenDirectory)
    const directoryId = path[path.length - 1]
    const content = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/content/theFrontDeskQueriesTheContentAccordingToTheCatalogId?catalogId=${directoryId}`)
    runInAction(() => {
      this.childrenDirectory = childrenDirectory
      this.level1Selected = level1Selected
      this.childrenSelected = directoryId
      this.content = content
      this.openKeys = path.slice(0, path.length - 1)
      this.directoryName = name
      this.loading = false
    })
  }

  @action
  loadContents = async(id,name) => {
    runInAction(()=>{
      this.loading = true;
    })
    const content = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/eAtlas/content/theFrontDeskQueriesTheContentAccordingToTheCatalogId?catalogId=${id}`)
    if(content && content.status === 0){
      runInAction(()=>{
        this.loading = false;
      })
      return
    }
    runInAction(()=>{
      this.content = content
      this.childrenSelected = id
      this.loading = false
      this.directoryName = name
    })
  }
  // @action showDetail = () =>{
  //   runInAction(()=>{
  //     this.modal = 'show'
  //   })
  // }
  // @action cancelEdit = () =>{
  //   runInAction(()=>{
  //     this.modal = 'hide'
  //   })
  // }
  __findChildrenDirectoryPathAndName(directory) {
    let d = directory
    const path = []
    for (let i = 0; i < 20; i++) {
      path.push(d[0].id)
      if (d[0].children.length) {
        d = d[0].children
      } else {
        break
      }
    }
    return {path, name: d[0].defaultName}
  }
}

export default new EAtalsContents()


// WEBPACK FOOTER //
// ./src/project/dongfeng/eAtlas/EAtalsContent/store.js